import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "attach",
  "use": "attach-usage",
  "viewBox": "0 0 11 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 23\" id=\"attach\"><path d=\"M9.5 5.5V17c0 2.21-1.79 4-4 4s-4-1.79-4-4V4.5a2.5 2.5 0 0 1 5 0V15c0 .55-.45 1-1 1s-1-.45-1-1V5.5H3V15a2.5 2.5 0 0 0 5 0V4.5c0-2.21-1.79-4-4-4s-4 1.79-4 4V17c0 3.04 2.46 5.5 5.5 5.5S11 20.04 11 17V5.5H9.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol